import React from "react";

interface ButtonProps {
    label: string
    color: string
    name?: string 
    onClickHandler?: (event: React.MouseEvent<HTMLDivElement>) => void
}

const MainButton: React.FC<ButtonProps> = ({
    label,
    color,
    name,
    onClickHandler
}) => {
    return (
            <div className={`p-3 ${color} text-white text-center rounded-full shadow`}
            onClick={e => {if (onClickHandler) onClickHandler(e)}}>
                {label}
            </div>
    )
}

export default MainButton